module.exports = __webpack_public_path__ + "static/customer-headshot-3@2x-a16989a38cfbb850a8dcd7ad3e071f19.jpg";